import React from 'react'
import ToolbarButton from '../Page/ToolbarButton'
import SearchFieldContainer from './SearchFieldContainer'
import { preventDefault, onEscape } from '../../utils/events'
import SearchIcon from '@material-ui/icons/Search'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { withStyles } from '@material-ui/core/styles'

const styles = {
	form: {
		width: '100%',
		display: 'flex'
	}
}

const Search = ({ onSearch, onClose, classes }) => (
	<form name="search" className={classes.form} onSubmit={preventDefault(onSearch)} onKeyDown={onEscape(onClose)}>
		<ToolbarButton
			title = "Tillbaka"
			icon = {<ArrowBackIcon />}
			onClick = {onClose}
		/>
		<SearchFieldContainer />
		<ToolbarButton
	  		title = "Sök"
	  		icon = {<SearchIcon />}
	  		type = "submit"
	  	/>
	</form>
)

export default withStyles(styles)(Search)



// WEBPACK FOOTER //
// ./src/components/MapMenu/Search.js